import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueSwal from 'vue-swal'
import helpers from './helpers'
import FBSignInButton from 'vue-facebook-signin-button'
import Sticky from 'vue-sticky-directive'
import 'animate.css/animate.css'
import store from './store'
import money from 'v-money'
import VueConfetti from 'vue-confetti'
import OneSignalVue from 'onesignal-vue'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import pkg from '../package.json'
import GoogleMapsPlugin from '../../plugins/google-maps';
import BgReload from "../../plugins/backgroundReload";

import 'bootstrap/dist/css/bootstrap.min.css'
import '../../assets/css/main.css'
import 'leaflet/dist/leaflet.css';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/brands.css';
import '@fortawesome/fontawesome-free/css/v4-font-face.css';
import '@fortawesome/fontawesome-free/css/v4-shims.css';

const environment = process.env.VUE_APP_ENVIRONMENT || 'production';
const envEmpresa = environment !== 'production' ? process.env : window.__EMPRESA__ || {};

if (environment === 'production') {
  Sentry.init({
    Vue: Vue,
    environment: environment,
    release: pkg.version,
    dsn: "https://9d16d05505974beb84adafc2cc03fd99@o449432.ingest.sentry.io/5851645",
    integrations: [new Integrations.BrowserTracing({
      tracingOrigins: [/^\//],
    })],

    tracesSampleRate: environment === 'production' ? 0.2 : 1,
    logErrors: environment !== 'production',
    attachProps: true,
    attachStacktrace: true,

    beforeSend(event, hint) {
      if (hint.originalException === "Timeout") return null;
      return event;
    }
  });
}

Vue.use(VueSwal);
Vue.use(helpers);
Vue.use(VueResource);
Vue.use(FBSignInButton);
Vue.use(Sticky);
Vue.use(VueConfetti);
Vue.use(OneSignalVue);
Vue.use(GoogleMapsPlugin);
Vue.use(BgReload);

Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2,
  masked: false
});

Vue.config.productionTip = false;

Vue.filter('valor', function (value) {
  if (value === undefined || value === null) {
    return value;
  }
  let formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

Vue.filter('getDay', function (value) {
  if (value === undefined || value === null) {
    return value;
  }

  switch (value) {
    case "1":
      return "Domingo";
    case "2":
      return "Segunda-Feira";
    case "3":
      return "Terça-Feira";
    case "4":
      return "Quarta-Feira";
    case "5":
      return "Quinta-Feira";
    case "6":
      return "Sexta-Feira";
    case "7":
      return "Sábado";
    default:
      return value
  }
});

Vue.filter('percent', function (value) {
  if (value !== null || value !== undefined) {
    return parseFloat(value).toFixed();
  }
});

Vue.filter('kilometer', function (value) {
  if (value !== null || value !== undefined) {
    const formated = parseFloat(value / 1000).toFixed(1);
    return formated + ' km';
  }
});

Vue.filter('maskPhone', function (phone) {
  if (phone && !isNaN(phone)) {
    if (phone.length === 10) {
      return phone.replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

    } else if (phone.length === 11) {
      return phone.replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
  }

  return phone
});

Vue.filter('tempo', function (value) {
  if (!isNaN(value)) {
    value = parseInt(value || '0');

    if (!value) {
      return `Hoje`;

    } else {
      return value >= 1440 ? `${(value / 1440).toFixed()} dia${value > 2159 ? 's' : ''}` : `${value} mins`;
    }
  }
});

let domain = envEmpresa.VUE_APP_DOMAIN || null;
let assets = envEmpresa.VUE_APP_ASSETS || null;
const base_server = getAmbiente() + '/delivery/';
const base_cdn = 'https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-corporativo';
const base_assets = envEmpresa.base_assets || `${base_cdn}/companies/${assets || domain}`;

function getAmbiente() {
  const base_server = envEmpresa.VUE_APP_BASE_SERVER || null;

  if (base_server) {
    return base_server;
  }

  const ambiente = envEmpresa.VUE_APP_AMBIENTE || null;

  switch (ambiente) {
    case '4':
      return 'http://localhost:9010';

    case '3':
      return 'https://dev.lecard.app.br';

    case '2':
      return 'https://beta.lecard.app.br';

    default:
      return 'https://delivery.lecard.app.br';
  }
}

function getAndroidInstalled() {
  try {
    const hasReferrer =
      typeof document !== 'undefined' &&
      document.referrer &&
      document.referrer.includes('android-app://');

    const hasSession =
      typeof window !== 'undefined' &&
      window.sessionStorage &&
      window.sessionStorage.getItem('android-app');

    return !!(hasReferrer || hasSession);
  } catch (e) {
    return false;
  }
}

const primary_color = envEmpresa.primary_color || envEmpresa.VUE_APP_THEME || null;
const secondary_color = envEmpresa.secondary_color || envEmpresa.VUE_APP_SECOND_COLOR || null;

if (primary_color && secondary_color) {
  document.documentElement.style.setProperty('--lecard-primary', primary_color);
  document.documentElement.style.setProperty('--lecard-secondary', secondary_color);
}

const isAndroid = /(android)/i.test(navigator.userAgent);
const isInstagram = /instagram/i.test(navigator.userAgent);
const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

Vue.mixin({
  data() {
    return {
      envEmpresa,
      app_version: pkg.version,
      oneSignalIntegration: (envEmpresa.VUE_APP_ONE_SIGNAL_ID !== undefined),
      franquiasEnabled: (envEmpresa.VUE_APP_FRANQUIA === 'true'),
      origin: '1',

      base_cdn,
      base_assets,
      server: base_server,
      dominio: envEmpresa.VUE_APP_DOMAIN,

      isInstagram,
      isAndroid,
      isIOS,
      android_installed: getAndroidInstalled(),
      ios_installed: (window.navigator.standalone === true),

      img_default: (base_cdn + '/static/imgs/default.png'),
      is_plus: parseInt(envEmpresa.VUE_APP_ID_PLANO || '1') === 2,
      modo_catalogo: false
    }
  },

  methods: {
    setSentry(data) {
      Sentry.setUser(data);
    }
  }
});

Vue.http.options.emulateJSON = true;
Vue.http.options.emulateHTTP = true;
Vue.http.options.root = base_server;

new Vue({
  el: '#app',
  router,
  directives: {Sticky},
  store,
  render: h => h(App),
  beforeMount() {
    if (envEmpresa.VUE_APP_ONE_SIGNAL_ID) {
      this.$OneSignal.init({ appId: envEmpresa.VUE_APP_ONE_SIGNAL_ID });
    }
  }
});
